import React from 'react';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';

import { ApolloProvider } from 'react-apollo';
import AWSAppSyncClient from 'aws-appsync';
import { Rehydrated } from 'aws-appsync-react';
import Amplify, { Auth } from 'aws-amplify';

import AWSExports from './aws-exports';
import appSyncConfig from './AppSync';

import Landing from './components/Landing';
import About from './components/About';
import Contact from './components/Contact';
import Admin from './components/Admin';
import PageNotFound from './components/PageNotFound';
import GoogleTagManager from './components/GoogleTagManager';
import { GTM_ID } from './constants';

Amplify.configure(AWSExports);

const client = new AWSAppSyncClient({
  url: appSyncConfig.graphqlEndpoint,
  region: appSyncConfig.region,
  auth: {
    // API Key
    // type: appSyncConfig.authenticationType,
    // apiKey: appSyncConfig.apiKey,
    // IAM
    type: appSyncConfig.authenticationType,
    // Amazon Cognito Federated Identities using AWS Amplify
    credentials: () => Auth.currentCredentials(),
    // credentials: new Credentials({
    //   accessKeyId: AWS_ACCESS_KEY_ID,
    //   secretAccessKey: AWS_SECRET_ACCESS_KEY,
    // }),
  },
});

const Refresh = ({ path = '/' }) => (
  <Route
    path={path}
    component={({ history, location, match }) => {
      history.replace({
        ...location,
        pathname: location.pathname.substring(match.path.length),
      });
      return null;
    }}
  />
);

const event = { platform: 'react-stack' };

const App = () => (
  <Router>
    <div>
      <Switch>
        <Route exact path="/" component={Landing} />
        <Route exact path="/About" component={About} />
        <Route exact path="/Contact" component={Contact} />
        <Route exact path="/Admin" component={Admin} /> 
        <Route exact path="/Admin/:new" component={Admin} />
        <Refresh path="/refresh" />
        <Route component={PageNotFound} status={404} />
      </Switch>
      <GoogleTagManager
        gtmId={GTM_ID}
        scriptId="react-google-tag-manager-gtm"
        dataLayerName="dataLayer"
        additionalEvents={event}
      />
    </div>
  </Router>
);

const WithProvider = () => (
  <ApolloProvider client={client}>
    <Rehydrated>
      <App />
    </Rehydrated>
  </ApolloProvider>
);

export default WithProvider;



// WEBPACK FOOTER //
// ./src/App.js